import type { ReactNode } from 'react';
import { cn } from '../cn.js';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

/** A small rounded label for statuses, roles and counts. */
export function Badge({ children, tone = 'neutral', className }: BadgeProps): JSX.Element {
  return <span className={cn('as-badge', `as-badge--${tone}`, className)}>{children}</span>;
}
